import classNames from 'classnames/bind';
import Dimmer from 'mcs-toolkit/components/Dimmer';
import React from 'react';
import ReactDOM from 'react-dom';
import UAParser from 'ua-parser-js';

import InfoIcon from 'reactApp/components/icons/info';
import CloseIcon from 'reactComponents/icons/close';

import styles from './ServerHintSSH.css';

const css = classNames.bind(styles);

export class ServerHintSSH extends React.PureComponent {
    static defaultProps = {
        afterClose: () => {},
    };

    state = {
        isOpen: true,
        browser: 'chrome',
    };

    componentDidMount() {
        const parser = new UAParser();
        this.setState({
            browser: parser.getResult().browser.name.toLocaleLowerCase(),
        });
    }

    handleCloseClick = () => {
        const { afterClose } = this.props;

        this.setState({ isOpen: false }, () => {
            setTimeout(() => {
                afterClose();
            }, 0);
        });
    };

    handleHintClick = (event) => {
        event.stopPropagation();
    };

    render() {
        return (
            <div>
                <Dimmer
                    className={css('dimmerBig')}
                    active={this.state.isOpen}
                    onClick={this.handleCloseClick}
                >
                    <div
                        className={css('hint', this.state.browser)}
                        onClick={this.handleHintClick}
                    >
                        <CloseIcon
                            className={css('close')}
                            onClick={this.handleCloseClick}
                        />
                        <div className={css('icon')}>
                            <InfoIcon />
                        </div>
                        <div>
                            <div className={css('title')}>
                                Скачивание ключевой пары
                            </div>
                            <div className={css('text')}>
                                Вы сможете найти ключевую пару
                                <br />
                                сразу после завершения скачивания
                                <br />в разделе «Загрузки» вашего браузера
                            </div>
                        </div>
                    </div>
                </Dimmer>
            </div>
        );
    }
}

export const ServerHintSSHRenderer = {
    render: () => {
        const targetContainer = document.createElement('div');
        document.body.appendChild(targetContainer);

        ReactDOM.render(
            <ServerHintSSH
                afterClose={() => {
                    document.body.removeChild(targetContainer);
                }}
            />,
            targetContainer,
        );
    },
};
